import './results.css';
import { useMemo, useRef } from 'react';
import { IListings } from '../../models/listings.model';
import ListingPreview from '../../listing-preview';
import { RESULTS_SORT_OPTIONS } from '../../util/listing-search.constants';
import { IListing } from '../../models/listing.model';
import { Pagination } from '../pagination/pagination';

export interface ResultsProps {
  title: string;
  listings: IListings;
  sortBy: string;
  activePreviewListingId: string;
  isHeaderDisabled?: boolean;
  isSavedListing(value: string): boolean;
  setSortBy(value: string): void;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
  setActivePreviewListingId(value: string): void;
}

export const Results = (props: ResultsProps) => {
  const resultsRef = useRef<HTMLDivElement | null>(null);

  const listingsFound = useMemo(
    () => (<h2>{props.listings.total > 0 ? <><span style={{ color: 'var(--default-font-highlight-color)' }}>{props.listings.total}</span> Listings</> : <>&nbsp;</>}</h2>),
    [props.listings.total]
  );

  return (
    <div ref={ref => (resultsRef.current = ref)} id="results" className={props.listings.loading ? 'results results-loading' : 'results'}>
      {!props.isHeaderDisabled &&
        <div className="results-summary">
          <div>
            <h1>{props.title}</h1>
            {listingsFound}
          </div>
          <div className="results-options">
            <div>Sort:</div>
            <div>
              <select defaultValue={props.sortBy} className="results-options-select-input" name="sortBy" onChange={e => props.setSortBy(e.target.value)}>
                {RESULTS_SORT_OPTIONS.map((option, i) =>
                  <option key={i} value={option.value}>{option.label}</option>
                )}
              </select>
            </div>
          </div>
        </div>
      }
      {props.listings.total === 0 &&
        <span className="no-results-found">No listings found.</span>
      }
      <div className="results-list">
        {props.listings.properties !== undefined && props.listings.properties.map((listing, i) =>
          <div key={i} onMouseEnter={() => props.setActivePreviewListingId(listing.id)} onMouseLeave={() => props.setActivePreviewListingId('')} className={props.activePreviewListingId === listing.id ? "results-list-item results-list-item-active" : "results-list-item"}>
            <ListingPreview
              listing={listing}
              isSavedListing={props.isSavedListing}
              addSavedListing={props.addSavedListing}
              removeSavedListing={props.removeSavedListing}
            />
          </div>)}
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <Pagination
        resultsRef={resultsRef}
        activePage={props.listings.page_num}
        maxButtons={5}
        itemsPerPage={props.listings.page_size}
        totalItems={props.listings.total}
      />
    </div>
  );
}

export default Results;
